import { CountryPath } from "src/entities/CountryPath";
import { CreditInfo } from "src/entities/v3/AuthMeResponse";

export const checkSubscripted = (
  credits: CreditInfo[] | undefined,
  country: CountryPath
): boolean => {
  const credit = credits?.find((value) => value.country === country);
  return credit ? credit.subscription : false;
};
